<template>
  <div class="prontopaga-box">
    <!-- Botón lanzador -->
    <!-- <v-btn :block="block" depressed color="transparent" class="ppg-launcher" :disabled="loading" @click="open">
      <v-img :src="buttonImageUrl" contain :max-height="buttonMaxHeight" :max-width="buttonMaxWidth" class="mx-auto"/>
    </v-btn> -->

    <!-- Popup -->
    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      :max-width="maxWidth"
      scrollable
      :persistent="persistent"
    >
      <v-card class="ppg-card">
        <!-- Header -->
        <div class="ppg-header">
          <div class="ppg-chip"><v-icon size="16" class="mr-1">mdi-shield-check</v-icon> Pago seguro</div>
          <h3 class="ppg-title">{{ title }}</h3>
          <v-btn icon class="ppg-close" @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </div>

        <v-card-text class="ppg-body">
          <!-- PASO 1: FORMULARIO -->
          <v-form v-if="step===1" ref="form" v-model="valid" lazy-validation class="ppg-form">
            <!-- Monto -->
            <div class="ppg-amount">
              <label class="ppg-amount__label">Monto (CLP)</label>
              <v-text-field
                v-model.number="amountClp"
                type="number" min="1" step="1" prefix="$"
                :rules="[v => v!=='' || 'Requerido', v => Number(v) >= 1 || 'Debe ser mayor o igual a 1']"
                hide-details="auto" outlined dense class="ppg-amount__input"
              />
              <small class="ppg-amount__hint">Ingresa el monto que deseas recargar</small>
            </div>

            <!-- Quitado campo Referencia, todo lo demás requerido -->
            <div class="ppg-grid">
              <v-text-field
                v-model="email" label="Email" type="email" outlined dense class="ppg-input"
                :rules="[v => !!v || 'Requerido']"
              />
              <v-text-field
                v-model="phone" label="Teléfono (+56 ...)" outlined dense class="ppg-input"
                :rules="[v => !!v || 'Requerido']"
              />
              <v-text-field
                v-model="rut" label="RUT (12.345.678-9)" outlined dense class="ppg-input"
                :rules="[v => !!v || 'Requerido']"
              />
              <v-text-field
                v-model="name" label="Nombre y Apellido" outlined dense class="ppg-input"
                :rules="[v => !!v || 'Requerido']"
              />
            </div>

            <v-btn class="ppg-cta" :loading="loading" :disabled="!valid || loading" @click="goToMethods">
              <v-icon left>mdi-arrow-right</v-icon> Continuar
            </v-btn>
            <p class="ppg-help">Pagos cifrados. Nunca almacenamos tu tarjeta.</p>
          </v-form>

          <!-- PASO 2: ELECCIÓN DE MÉTODO (desde /prontopaga/metodos) -->
          <div v-else-if="step===2" class="ppg-methods">
            <div class="ppg-methods__head">
              <h4>Elige un método de pago</h4>
              <v-btn small text class="ppg-back" @click="step=1"><v-icon left small>mdi-arrow-left</v-icon> Volver</v-btn>
            </div>

            <div v-if="loading" class="ppg-loading"><div class="ppg-spinner"></div> Cargando métodos…</div>

            <div v-else class="ppg-methods__list">
              <v-item-group v-model="selectedMethodId" mandatory>
                <v-item
                  v-for="m in methods" :key="m.id" :value="m.id"
                  v-slot="{ active, toggle }"
                >
                  <div class="ppg-method" :class="{ 'ppg-method--active': active }" @click="() => { toggle(); selectedMethodCode = m.method }">
                    <div class="ppg-method__left">
                      <img v-if="m.logo" :src="m.logo" :alt="m.name" class="ppg-method__logo"/>
                      <div class="ppg-method__name">{{ m.name }} <small class="ppg-method__cur">({{ m.currency }})</small></div>
                    </div>
                    <v-icon v-if="active" class="ppg-ok">mdi-check-circle</v-icon>
                    <v-icon v-else class="ppg-off">mdi-checkbox-blank-circle-outline</v-icon>
                  </div>
                </v-item>
              </v-item-group>
            </div>

            <v-btn
              class="ppg-cta"
              :disabled="!selectedMethodId || loading"
              :loading="loadingStart"
              @click="startCheckout"
            >
              <v-icon left>mdi-lock</v-icon>
              Pagar con {{ currentMethodName }}
            </v-btn>
            <p class="ppg-help">Si el método no permite embebido, se abrirá en una pestaña nueva.</p>
          </div>

          <!-- PASO 3: CHECKOUT -->
          <div v-else-if="step===3">
            <div v-if="payUrl" class="ppg-iframe-wrap">
              <iframe
                v-show="iframeOk"
                :src="payUrl"
                class="ppg-iframe"
                frameborder="0"
                allow="payment *"
                @load="onIframeLoad"
              ></iframe>

              <div v-if="!iframeOk" class="ppg-loading ppg-loading--center" style="padding:16px;">
                <div class="ppg-spinner"></div>
                <span v-if="!embedFailed" class="ml-2">Cargando checkout…</span>
                <span v-else class="ml-2">
                  El proveedor no permite iFrame. 
                  <a :href="payUrl" target="_blank" rel="noopener">Ábrelo aquí</a>.
                </span>
              </div>
            </div>

            <div v-else class="ppg-loading ppg-loading--center"><div class="ppg-spinner"></div> Procesando…</div>

            <div v-if="!payUrl && !loading" class="ppg-edit">
              <v-btn text small class="ppg-edit-btn" @click="editAgain"><v-icon left small>mdi-pencil</v-icon> Editar datos</v-btn>
            </div>
          </div>
        </v-card-text>

        <v-card-actions class="ppg-actions">
          <v-spacer/>
          <v-btn text class="ppg-secondary" @click="close">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ProntopagaChile',
  props: {
    basePath: { type: String, default: '' }, // usa '/api' si corresponde
    title: { type: String, default: 'Recarga tu Cartera (CLP)' },
    block: { type: Boolean, default: true },
    maxWidth: { type: [Number, String], default: 600 },
    persistent: { type: Boolean, default: false },
    buttonImageUrl: { type: String, default: 'https://trackandraces.com/cuentas/tarjetatar.png' },
    buttonMaxWidth: { type: [Number, String], default: 220 },
    buttonMaxHeight: { type: [Number, String], default: 90 },
    defaultAmountClp: { type: [Number, String], default: '' },
    defaultEmail: { type: String, default: 'clecov@gmail.com' },
    defaultPhone: { type: String, default: '994533709' },
    defaultRut: { type: String, default: '11.111.111-1' },
    defaultName: { type: String, default: 'CLEOFE COVA' },
  },
  data: () => ({
    dialog: false,
    valid: false,
    loading: false,
    loadingStart: false,
    step: 1,

    // métodos de /prontopaga/metodos (retorno[])
    methods: [],
    selectedMethodId: null,
    selectedMethodCode: null, // ej: "mach_payment", "webpay_payment"

    // form
    amountClp: '1000',
    email: 'clecov@gmail.com',
    phone: '994533709',
    rut: '11.111.111-1',
    name: 'CLEOFE COVA',

    // checkout
    orderId: null,
    clientTxId: null,
    payUrl: '',         // <<-- URL final a mostrar (raw.urlPay / iframeUrl / checkoutUrl)
    iframeOk: false,
    embedFailed: false,
    iframeTimeoutId: null,

    cachedMethods: false,
  }),
  computed: {
    currentMethodName() {
      const m = this.methods.find(x => x.id === this.selectedMethodId);
      return m?.name || 'ProntoPaga';
    },
  },
  mounted() {
    this.amountClp = this.defaultAmountClp || this.amountClp;
    this.email = this.defaultEmail;
    this.phone = this.defaultPhone;
    this.rut = this.defaultRut;
    this.name = this.defaultName;

    window.addEventListener('message', this.onProntoMessage);
  },
  beforeDestroy() {
    window.removeEventListener('message', this.onProntoMessage);
  },
  methods: {
    open(){ this.dialog = true; this.step = 1; },
    close(){ this.dialog=false; this.reset(); this.$emit('closed'); },
    reset(){
      this.loading = this.loadingStart = false;
      this.step = 1; this.orderId = null; this.clientTxId = null;
      this.selectedMethodId = null; this.selectedMethodCode = null;
      this.payUrl = ''; this.iframeOk = false; this.embedFailed = false;
      if (this.iframeTimeoutId) { clearTimeout(this.iframeTimeoutId); this.iframeTimeoutId = null; }
    },
    editAgain(){ this.step = 1; this.payUrl = ''; this.iframeOk = false; this.embedFailed = false; },

    buildClientTxId(){
      const ts = Date.now();
      const rnd = Math.random().toString(36).slice(2,8);
      return `PPG-${ts}-${rnd}`; // < 50 chars
    },

    async goToMethods(){
      const ok = await this.$refs.form.validate();
      if (!ok) return;

      this.loading = true;
      try{
        if(!this.cachedMethods){
          const { data } = await axios.get(`${this.basePath}/prontopaga/metodos`);
          // Puede venir como {status:200, retorno:[...]} o {ok:true, metodos:[...]}
          const list = Array.isArray(data?.retorno) ? data.retorno : (data?.metodos || []);
          this.methods = list.map(m => ({
            id: m.id, name: m.name, method: m.method, currency: m.currency, logo: m.logo
          }));
          if(!this.methods.length) throw new Error('No hay métodos disponibles');
          this.cachedMethods = true;
        }
        this.step = 2;
      }catch(e){
        console.error(e);
        this.$emit('error', e?.response?.data?.message || e.message || 'No se pudieron cargar los métodos');
      }finally{
        this.loading = false;
      }
    },

    async startCheckout(){
      if(!this.selectedMethodId || !this.selectedMethodCode) return;

      this.loadingStart = true;
      this.iframeOk = false;
      this.embedFailed = false;
      this.payUrl = '';
      try{
        this.clientTxId = this.buildClientTxId();

        const payload = {
          amountClp: Number(this.amountClp),
          email: this.email,
          phone: this.phone,
          rut: this.rut,
          name: this.name,
          methodId: this.selectedMethodId,
          method: this.selectedMethodCode,
          clientTxId: this.clientTxId,
          // Si en algún flujo necesitas bankCode/useIframe, añádelos aquí
        };

        const { data } = await axios.post(`${this.basePath}/prontopaga/start`, payload);

        this.orderId = data?.orderId || data?.ordenId || null;

        // Preferencias: iframeUrl > checkoutUrl > raw.urlPay
        const raw = data?.raw || {};
        const url = data?.iframeUrl || data?.checkoutUrl || raw?.urlPay;

        if (!url) {
          throw new Error('El backend no devolvió una URL de pago (iframeUrl/checkoutUrl/urlPay)');
        }

        this.payUrl = url;
        this.step = 3;

        // Fallback si el proveedor bloquea el iFrame
        this.iframeTimeoutId = setTimeout(() => {
          if (!this.iframeOk) this.embedFailed = true;
        }, 4000);

        this.$emit('ready', { orderId: this.orderId, clientTxId: this.clientTxId, url: this.payUrl, method: this.selectedMethodCode });
      }catch(e){
        console.error(e);
        this.$emit('error', e?.response?.data?.message || e.message || 'Error iniciando pago');
        this.step = 2;
      }finally{
        this.loadingStart = false;
      }
    },

    onIframeLoad(){
      this.iframeOk = true;
      this.embedFailed = false;
      if (this.iframeTimeoutId) { clearTimeout(this.iframeTimeoutId); this.iframeTimeoutId = null; }
    },

    // postMessage desde tu retorno/iframe si lo implementas
    onProntoMessage(e){
      const msg = e.data || {};
      if(msg.type === 'PRONTOPAGA_DONE'){
        this.$emit('success', msg.payload || {});
        this.close();
      }else if(msg.type === 'PRONTOPAGA_ERROR'){
        this.$emit('error', msg.payload || 'Error en confirmación');
        this.close();
      }
    },
  },
};
</script>

<style scoped>
/* Popup sólido blanco (sin transparencia) */
.v-dialog .v-card,
.v-dialog .v-card > * { background-color:#ffffff !important; }
.v-overlay__scrim { background-color:rgba(15,23,42,.85) !important; backdrop-filter:none !important; }

/* Paleta clara minimalista */
.ppg-card{ border-radius:14px; box-shadow:0 18px 44px rgba(2,6,23,.16); overflow:hidden; }
.ppg-header{ position:relative; padding:18px 20px 10px; border-bottom:1px solid #e5e7eb; background:#fff; }
.ppg-title{ margin:12px 0 0; font-size:20px; font-weight:800; }
.ppg-chip{ display:inline-flex; align-items:center; font-size:12px; font-weight:600; color:#0f172a; background:#eef2ff; border:1px solid #e0e7ff; padding:6px 10px; border-radius:999px; }
.ppg-close{ position:absolute; right:6px; top:6px; color:#6b7280; }
.ppg-body{ padding:18px; }

.ppg-form{ border:1px solid #e5e7eb; border-radius:12px; padding:16px; background:#fff; }

/* Monto */
.ppg-amount{ border:1.5px solid #2563eb; border-radius:12px; padding:12px; margin-bottom:14px; background:#fff; box-shadow:0 0 0 4px rgba(37,99,235,.22); }
.ppg-amount__label{ font-weight:700; font-size:13.5px; color:#0f172a; }
.ppg-amount__input :deep(.v-input__slot){ border-radius:10px !important; min-height:52px !important; }
.ppg-amount__input :deep(input){ font-size:22px !important; font-weight:800 !important; color:#0f172a !important; }
.ppg-amount__hint{ display:block; margin-top:8px; font-size:12px; color:#6b7280; }

/* Inputs y grid */
.ppg-input :deep(.v-input__slot){ border-radius:10px !important; min-height:46px !important; }
.ppg-grid{ display:grid; grid-template-columns:1fr; grid-gap:12px; margin-top:6px; }
@media (min-width:520px){ .ppg-grid{ grid-template-columns:1fr 1fr; } }

/* Métodos */
.ppg-methods{ border:1px solid #e5e7eb; border-radius:12px; padding:14px; background:#fff; }
.ppg-methods__head{ display:flex; justify-content:space-between; align-items:center; margin-bottom:8px; }
.ppg-methods__list{ display:flex; flex-direction:column; gap:10px; }
.ppg-method{
  display:flex; align-items:center; justify-content:space-between;
  padding:10px 12px; border-radius:10px; border:1px solid #e5e7eb; background:#fff; cursor:pointer; transition:.15s;
}
.ppg-method:hover{ border-color:#c7d2fe; box-shadow:0 0 0 3px rgba(199,210,254,.5); }
.ppg-method--active{ border-color:#2563eb; box-shadow:0 0 0 3px rgba(37,99,235,.22); }
.ppg-method__left{ display:flex; align-items:center; gap:10px; }
.ppg-method__logo{ width:34px; height:22px; object-fit:contain; }
.ppg-method__name{ font-weight:700; color:#0f172a; }
.ppg-method__cur{ color:#6b7280; font-weight:600; }
.ppg-ok{ color:#22c55e; } .ppg-off{ color:#cbd5e1; }

/* CTA */
.ppg-cta{ margin-top:14px; width:100%; color:#fff !important; background:#ef4444 !important; text-transform:none; font-weight:800; border-radius:10px; height:46px; }
.ppg-cta:hover{ background:#dc2626 !important; }
.ppg-help{ margin:10px 2px 0; font-size:12px; color:#6b7280; }

/* Checkout embebido */
.ppg-iframe-wrap{ margin-top:14px; border:1px solid #e5e7eb; border-radius:12px; overflow:hidden; }
.ppg-iframe{ display:block; width:100%; height:620px; background:#fff; }

/* Loading */
.ppg-loading{ display:flex; align-items:center; gap:10px; color:#6b7280; font-size:13px; }
.ppg-loading--center{ justify-content:center; margin:16px 0; }
.ppg-spinner{ width:18px; height:18px; border-radius:999px; border:2px solid #e5e7eb; border-top-color:#2563eb; animation:spin 1s linear infinite; }
@keyframes spin{ to{ transform:rotate(360deg); } }

/* Footer & launcher */
.ppg-actions{ padding:10px 14px 16px; border-top:1px solid #e5e7eb; }
.ppg-secondary{ color:#6b7280 !important; text-transform:none; }
.ppg-launcher{ padding:0; min-height:auto; box-shadow:none; }
.ppg-launcher:hover{ transform:scale(1.02); }

@media (max-width:360px){
  .ppg-body{ padding:14px; }
  .ppg-form{ padding:12px; }
  .ppg-title{ font-size:18px; }
}
</style>
